/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface ComponentConfigsWithDeploymentIdSpec { 
    deployment_id: string;
    vcds_service_type: VcdsServiceTypeEnum;
    configs?: object;
}
export namespace ComponentConfigsWithDeploymentIdSpec {
}


